import { Meta, StoryObj } from '@storybook/react';

import { List } from './List';

const meta: Meta<typeof List> = {
  title: 'parts/text/List',
  component: List,
};

export default meta;

type Story = StoryObj<typeof List>;

export const Basic: Story = {
  render: () => (
    <List>
      <li>項目項目項目項目項目項目項目項目項目項目</li>
      <li>項目項目項目項目項目</li>
      <li>項目項目項目項目項目</li>
    </List>
  ),
};
